__webpack_require__.p = "/investigations/china-the-superpower-of-seafood/";